export const handleDatetime = (data, convertMonth) => {
  const date = new Date(data);
  if (convertMonth) {
    let shortMonth = date.toLocaleString("en-us", { month: "short" });
    let shortDate = date.getDate();
    return shortMonth + " " + shortDate;
  } else {
    const newDateTime =
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    return newDateTime;
  }
};
export const handleValue = (value) => {
  if (value === 0) return 0;
  else {
    const newValue = String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const finalValue = newValue.slice(0, -1) + "K";
    return finalValue;
  }
};

const CustomTooltip = ({ payload, active }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        {/* <p className="label">{`${handleValue(payload[0].payload.value)}`}</p> */}
        <p className="label">{`${payload[0].payload.value}`}</p>
        <p className="desc">{`${handleDatetime(
          payload[0].payload.datetime,
          false
        )}`}</p>
      </div>
    );
  }
  return null;
};
export default CustomTooltip;
